module.exports = __webpack_public_path__ + "img/jsxlk.badcd7c2.png";